function getFileExtension(contentType: any): any {
  switch (contentType) {
    case "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet":
      return ".xlsx";
    case "application/msword":
      return ".doc";
    case "image/png":
      return ".png";
    case "application/zip":
      return ".zip";
    case "application/octet-stream":
      return ".tar";
    default:
      return ".txt"; // Default extension if type is unknown
  }
}

export default getFileExtension;
